import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';

const ToolkitHeader: React.FC = () => {
  return (
    <section className="bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-4 border border-white/20">
            <SparklesIcon className="w-5 h-5 text-yellow-300" />
            <span className="text-sm font-medium">
              Your Property Management Hub
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Landlord Toolkit
          </h1>

          <p className="text-xl text-blue-100 mb-6">
            Everything you need to manage your rental properties professionally.
            Add a new managed property, view your portfolio, and curate your public listings
            all from one convenient dashboard.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ToolkitHeader;
